<template>
	<label class="d21-toggler mdl-switch is-upgraded" :class="{ 'is-checked': inputVal }">
		<input type="checkbox" class="mdl-switch__input" v-model="inputVal">
		<span v-if="label" class="mdl-switch__label">
			{{ label }}
			<template v-if="tooltip && tooltip.length">
				<i class="icon-info ml-05" :content="tooltip" v-tippy />
			</template>
		</span>

		<div class="mdl-switch__track"></div>
		<div class="mdl-switch__thumb">
			<span class="mdl-switch__focus-helper"></span>
		</div>
	</label>
</template>

<script>
	export default {
		name: "d21-toggler",
		props: ["value", "label", "tooltip"],
		data() {
			return {
				inputVal: this.value
			};
		},
		watch: {
			inputVal(val) {
				this.$emit("input", val);
			}
		}
	};
</script>